import { render, staticRenderFns } from "./quote-email.vue?vue&type=template&id=220f2637&"
import script from "./quote-email.vue?vue&type=script&lang=js&"
export * from "./quote-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports